import React from 'react';
import Helmet from 'react-helmet';
import Card from 'react-toolbox/lib/card';
import Logo from '../Logo';
import CardBody from '../CardBody';
import ResetPasswordForm from '../ResetPasswordForm';
import LeftPane from '../layout/LeftPane';
import styles from './ResetPasswordPage.scss';

const ResetPasswordPage = () => {
  return (
    <LeftPane className={`col-xs-12 col-sm-6 ${styles.leftPaneWithOverflow}`}>
      <Helmet title="Reset Password" />
      <Card className={styles.cardWithOverflow}>
        <CardBody>
          <Logo />
          <div className="text--preamble text-size-md mb-2">
            <h2>Reset your password</h2>
          </div>
          <ResetPasswordForm />
        </CardBody>
      </Card>
    </LeftPane>
  );
};

export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./src/client/src/components/pages/ResetPasswordPage.js